import React from "react";
import { useRole } from "../hooks/useRole";
import ProtectedRoutes from "./ProtectedRoutes";

/**
 * AdminOrPermission — a route the platform admin always reaches and any other
 * seat reaches with the named permission (marketing staff, 2026-10).
 *
 * It mirrors the API: requireAdminPermission admits the platform admin before
 * it looks at any grant, and admits a staff seat on the exact
 * "Section:Action". Gating the AD on the permission matrix instead would lock
 * the AD out of a screen on any environment where the catalog row it needs
 * (e.g. Careers:View, Marketing Campaigns:View) has not been granted to its
 * shadow yet.
 *
 * requiredPath takes what ProtectedRoutes takes (one path, or an any-of list).
 */
function AdminOrPermission({ requiredPath, children }) {
  const { hasRole } = useRole();
  if (hasRole("AD")) return children;
  return <ProtectedRoutes requiredPath={requiredPath}>{children}</ProtectedRoutes>;
}

export default AdminOrPermission;
